import { Dialog, DialogContent, DialogProps, Stack } from "@mui/material";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import ExportDataForm, { DataExportProps } from "./DataExportForm";

export interface OwnProps {
  dataExportProps: DataExportProps;
}

type Props = OwnProps & DialogProps;

export default function DataExportModal({ dataExportProps, ...dialogProps }: Props) {
  return (
    <Dialog fullWidth maxWidth='md' {...dialogProps}>
      <AppModalTitle
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >
        Data export
      </AppModalTitle>
      <DialogContent>
        <Stack sx={{ py: 1 }} spacing={1}>
          <ExportDataForm
            {...dataExportProps}
            onExportDone={() => dialogProps.onClose && dialogProps.onClose({}, "escapeKeyDown")}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
